import Grid from '@material-ui/core/Grid';
import SettingConfirmRow from './SettingConfirmRow';
import { Typography } from "@material-ui/core";
import { modalStressTextColor, modalTextColor } from "../../lib/Color";
import { TeamType, PositionType } from "../../Type/TeamType"
import { StateType, ModeType } from "../hooks/AssetSettingModalType"

// TODO 変数名をわかりやすい名前に
type TeamNameFontSize = 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'caption'
    | 'button'
    | 'overline'
    | 'srOnly'
    | 'inherit'

type Props = {
    state: StateType;
    teamNameFontSize?: TeamNameFontSize;
    team: TeamType;
    switchingStatePlayer: () => void;
    onSelectStateModeAndPosition: (mode: ModeType, position: PositionType) => void,
}

const SettingConfirmArea = ({ state, teamNameFontSize = "h5", team, switchingStatePlayer, onSelectStateModeAndPosition }: Props) => {
    return (
        <Grid container alignItems="center" direction="column">
            <Grid item style={{ margin: "5px" }} >
                <Typography variant={teamNameFontSize}>
                    <span style={{ color: modalStressTextColor }} onClick={switchingStatePlayer}>{state.player}</span>
                </Typography>
            </Grid>
            <SettingConfirmRow selectedMode={state.mode} position={"FRONT"} member={team.front} selectedPosition={state.position} onSelectStateModeAndPosition={onSelectStateModeAndPosition} />
            <SettingConfirmRow selectedMode={state.mode} position={"MIDDLE"} member={team.middle} selectedPosition={state.position} onSelectStateModeAndPosition={onSelectStateModeAndPosition} />
            <SettingConfirmRow selectedMode={state.mode} position={"BACK"} member={team.back} selectedPosition={state.position} onSelectStateModeAndPosition={onSelectStateModeAndPosition} />
        </Grid>
    );
}

export default SettingConfirmArea;